/** Format an ISO timestamp as "just now" / "Nm ago" / "Nh ago" / short date. */
export function formatRelativeTime(iso: string): string {
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

/** Local part of an email — 'anthony' from 'anthony@solverminds.com'.
 *
 *  Shown beside an analysis so a reader can tell their own work from a
 *  colleague's before deciding whether to trust a cached result or re-run
 *  it. The domain is dropped as noise: everyone here shares one. */
export function emailName(email?: string | null): string | null {
  const v = (email ?? '').trim();
  if (!v || v === 'unknown') return null;
  const local = v.split('@')[0].trim();
  return local || null;
}
